import { ELang } from 'models/enums';
import { IIconLabelItem, IMenuItem, IServerObject, ICheckUrlItem, IServerItem, TServerIds } from 'models/types';

export * from './about';
export * from './winners';
export * from './operators';
export * from './prizes';

export const FEATURE_LIST: IIconLabelItem[] = [
  { name: 'RUBY', label: 'features.list.0' },
  { name: 'WAND', label: 'features.list.1' },
  { name: 'THUMB_UP', label: 'features.list.2' },
  { name: 'PLANT', label: 'features.list.3' }
];

export const INFO_LIST: IIconLabelItem[] = [
  { name: 'PURPOSE', label: 'info.list.0' },
  { name: 'FLAG', label: 'info.list.1' },
  { name: 'BULB_ON', label: 'info.list.2' },
  { name: 'RUBY', label: 'info.list.3' },
  { name: 'SHARE', label: 'info.list.4' }
];

export const RULE_URLS = [
  'https://tvoya-udacha.sz.kz/rules_ru.pdf',
  'https://static.sz.kz/content/gamesCatalog/docs/ogo-udacha-ru.pdf',
  'https://uda4a.sz.kz/rules_ru.pdf'
];
export const OFERTA_URL = '/oferta.pdf';
export const FEEDBACK_URL = 'mailto:lottery@cmid.kz';

export const DEFAULT_ARTIST = 'Smart Reading';

export const GA_TRACKING_ID = 'G-KBS6EKBDJ7';
export const YANDEX_ID = 93217884;
export const GOOGLE_TAG_MANAGER_ID = 'GTM-K5KMCPTH';

export const PORTAL_LINK = 'https://smartbooks.kz/';

export const CHECK_URL_LIST: ICheckUrlItem[] = [
  {
    url: 'http://udacha.sz.kz',
  },
  {
    url: 'http://tvoya-udacha.tele2.kz',
  },
  {
    url: 'http://tvoya-udacha.altel.kz',
  }
];

export const SERVER_KEY_MAP: Record<TServerIds, IServerItem> = {
  '0': {
    name: 'plug',
    url: null,
    getParams: ''
  },
  '207': {
    name: 'beeline',
    url: 'http://udacha.sz.kz',
    getParams: ''
  },
  '342': {
    name: 'tele2',
    url: 'http://tvoya-udacha.tele2.kz',
    getParams: '/?type=lottery'
  },
  '452': {
    name: 'kcell',
    url: 'http://udacha.sz.kz',
    getParams: ''
  },
  '454': {
    name: 'altel',
    url: 'http://tvoya-udacha.altel.kz',
    getParams: '/?type=lottery'
  }
};

export const LANGS = Object.values(ELang);

export const MENU_ITEMS: (action: () => void, currentRuleURL?: string) => IMenuItem[] = (action, currentRuleURL) => ([
  { name: 'participate', label: 'menu.participate', action },
  { name: 'prizes', label: 'menu.prizes', link: '#prizes' },
  { name: 'rules', label: 'menu.rules', link: currentRuleURL },
  { name: 'feedback', label: 'menu.feedback', link: FEEDBACK_URL }
]);
